import classNames from 'classnames'
import imgSoftware from 'legacy/lut/assets/img/icon-software.png'
import imgSpecializedIn from 'legacy/lut/assets/img/icon-specialized-in.png'
import imgComputing from 'legacy/lut/assets/img/specialization__computing.png'
import imgPrinting from 'legacy/lut/assets/img/specialization__printing.png'
import imgServices from 'legacy/lut/assets/img/specialization__services.png'
import imgSupplies from 'legacy/lut/assets/img/specialization__supplies.png'
import React from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'

import styles from './List.module.scss'

interface IProps {
  className?: string
  title: string
  selectedValues?: { name: string }[]
  dataSource: { name: string }[]
}

export const List = ({ className, title, selectedValues, dataSource }: IProps) => {
  const [dataset, setDataset] = React.useState<any[]>([])

  React.useEffect(() => {
    if (selectedValues && dataSource) {
      const newDataset: any[] = []
      selectedValues.forEach((value: any) => {
        const finded = dataSource && dataSource.find((item: any) => item.name === value.name)
        newDataset.push(finded)
      })
      setDataset([...newDataset])
    }
  }, [selectedValues, dataSource])

  const getListIcon = () => {
    if (title === 'partnerpreview-specialized-in') {
      return imgSpecializedIn
    } else if (title === 'partnerpreview-software') {
      return imgSoftware
    } else {
      return ''
    }
  }

  const getTileIcon = (name: string) => {
    if (name === 'Computing') {
      return imgComputing
    } else if (name === 'Printing') {
      return imgPrinting
    } else if (name === 'Services') {
      return imgServices
    } else if (name === 'Supplies') {
      return imgSupplies
    } else {
      return ''
    }
  }

  if (!dataset.length) {
    return null
  } else {
    return (
      <div className={classNames(styles.root, className || '')}>
        {title !== 'partnerpreview-industries-covered' ? (
          <>
            <header className={styles.header}>
              <div className={styles.header__icon}>
                <img src={getListIcon()} alt="" />
              </div>
              <p className={styles.header__title}>
                <Translation text={title} span />
              </p>
            </header>
            <ul className={styles.list}>
              {dataset.map((item, index) => {
                return (
                  <li className={styles.list__item} key={`list-${index}`}>
                    {item.name}
                  </li>
                )
              })}
            </ul>
          </>
        ) : (
          dataset.map((item, index) => {
            return (
              <div className={styles.tile} key={`tile-${index}`}>
                <img className={styles.tile__icon} src={getTileIcon(item.name)} alt="" />
                <p className={styles.tile__text}>{item.name}</p>
              </div>
            )
          })
        )}
      </div>
    )
  }
}
